import styled from 'styled-components';

export const Container = styled.section`
    padding: 48px;
`;
